/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import React from 'react';
import cx from 'classnames';
import { useLabels } from '@/hooks/useLabels';
import styles from './ContactUsModal.module.scss';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { routePaths } from '@/constants/routePaths';
import { useStoreDetailsData } from '@/features/header/api/getStoreDetails';
import { useHeaderData } from '../../header/api/getHeader';
import { useAppState } from '@/stores/AppState';

type Props = {
  onClick: () => void;
};

const chatBubblesIconWhite = {
  src: '/images/chat-bubbles-white.svg',
  width: 18,
  height: 22,
};

const labelMap = {
  lblContactUs: 'label_contact_us_tab',
};

export function NeedHelpTab({ onClick }: Props) {
  const { lblContactUs } = useLabels(labelMap);
  const router = useLegacyRouter();
  const { data: headerData } = useHeaderData();
  const miniCartMap = headerData?.miniCartMap;
  const itemCount = miniCartMap?.itemCount || 0;
  const isCartPage = router.asPath.includes(routePaths.cart);
  const isBrandsPage = router.asPath === routePaths.shopByBrand;
  const { data: storeData } = useStoreDetailsData();
  const isBopusEnabled = storeData?.bopusEnabled ?? false;
  const { isMobileApp } = useAppState().state;
  if (isMobileApp) {
    return null;
  }

  return (
    <button
      aria-label={lblContactUs}
      type="button"
      onClick={onClick}
      className={cx(styles.needHelpTab, {
        [styles.needHelpTabInCart]: isCartPage && itemCount > 0,
        [styles.needHelpTabInCartWithSTSForMX]: isCartPage && itemCount > 0 && !isBopusEnabled,
        [styles.needHelpTabBrands]: isBrandsPage,
      })}
    >
      <img
        className={styles.needHelpTabIcon}
        height={chatBubblesIconWhite.height}
        width={chatBubblesIconWhite.width}
        src={chatBubblesIconWhite.src}
        alt=""
        decoding="async"
      />
      <div className={styles.needHelpTabLabel}>{lblContactUs}</div>
    </button>
  );
}
